import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {ThemeModule} from '@app/themes/theme-module';
import {IMenuItem} from '@models/i-menu-item';
import {SummaryParent} from '@app/wrappers/summary-parent';
import {MenuChildrenPipe} from '@app/utils/pipes/menu-children.pipe';

@Component({
  selector: 'app-fields-identification',
  standalone: true,
  imports: [CommonModule, TranslateModule, ThemeModule, MenuChildrenPipe],
  templateUrl: './fields-identification.component.html',
  styleUrls: ['./fields-identification.component.scss'],
})
export class FieldsIdentificationPageComponent extends SummaryParent{
}
